import React, { Component } from "react";
import { t } from '../../i18n';
import { Mutation, Query } from "react-apollo";
import queries from "../../queries";
import { FormattedMessage } from "react-intl";
import "../../style/DisplayManagement.scss";
import NeedAdmin from "../NeedAdmin";
import { apolloClient } from "../../config";
import confirmDialog from "../dialogs/ConfirmDialog";
import MapPosition from "./MapPosition";
import DeviceRemoteControl from "./DeviceRemoteControl";

class DisplayManagement extends Component {

  constructor(props) {
    super(props);
    this.state = {
      project_id: "",
      name: "",
      filterText: "",
      filterGroup: "",
      group_id: null,
      group_change: false,
      location: "",
      location_change: false,
      alerte: false,
      alerteChanged: false,
    };
  }

  render() {
    const { displayId } = this.props.match.params;
    return (
      <NeedAdmin trueAdmin>
        <Query query={queries.displays.getDeviceById} variables={{ id: displayId }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <div className="tsk-display-management tsk-display-management--loading">Loading</div>;
            }
            if (error) {
              return <div className="tsk-display-management">{error.message}</div>;
            }

            const device = data.device;
            const last_location = device.last_location;

            if (device.location !== this.state.location && !this.state.location_change) {
              this.setState({ location: device.location });
            }

            if (!this.state.alerteChanged) {
              this.setState({ alerte: device.need_verify, alerteChanged: true });
            }

            const backHref =
              device.group_id == null
                ? "/admin/displaysGroup/bureau"
                : `/admin/displaysGroup/${device.group_id}`;

            return (
              <div className="tsk-display-management">
                <header className="tsk-display-management__header">
                  <button
                    type="button"
                    className="tsk-button tsk-display-management__back"
                    onClick={() => {
                      window.location.href = backHref;
                    }}
                  >
                    Retour
                  </button>
                  <div className="tsk-display-management__title-block">
                    <span className="tsk-display-management__eyebrow">
                      <FormattedMessage id="display.mananagement.display_id" />
                    </span>
                    <span className="tsk-display-management__badge">{device.physical_id}</span>
                  </div>
                </header>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">
                    <FormattedMessage id="display.mananagement.display_name" />
                  </h2>
                  <p className="tsk-display-card__current">
                    {(device.name == null) ? "No name" : device.name}
                  </p>
                  <Mutation mutation={queries.displays.update}>
                    {(updateName) => (
                      <div className="tsk-display-inline-fields">
                        <input
                          className="tsk-input-lines"
                          id="name"
                          type="text"
                          minLength={6}
                          maxLength={255}
                          placeholder={t('ui.disp.name_ph')}
                          value={this.state.name}
                          onChange={(e) => this.setState({ name: e.target.value })}
                        />
                        <button
                          type="button"
                          className="tsk-btn-update"
                          onClick={() => {
                            updateName({
                              variables: { input: { id: displayId, name: this.state.name } },
                            });
                          }}
                        >
                          <FormattedMessage id="display.mananagement.rename" />
                        </button>
                      </div>
                    )}
                  </Mutation>
                </section>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">
                    <FormattedMessage id="display.management.change_group" />
                  </h2>
                  <Query query={queries.displays.listGroup}>
                    {({ loading: lg, error: eg, data: gdata }) => {
                      if (lg) return "Loading";
                      if (eg) return eg.message;
                      const groups = gdata.devicesGroups;
                      if (this.state.group_id !== device.group_id && !this.state.group_change) {
                        this.setState({ group_id: device.group_id });
                      }
                      return (
                        <Mutation mutation={queries.displays.update}>
                          {(update) => (
                            <div className="tsk-display-stack">
                              <select
                                className="tsk-input-lines"
                                value={this.state.group_id == null ? "" : this.state.group_id}
                                onChange={(e) => {
                                  this.setState({ group_change: true, group_id: e.target.value });
                                }}
                              >
                                <option value="">Bureau</option>
                                {groups.map((group) => {
                                  if (!group.name.toLowerCase().includes(this.state.filterGroup.toLowerCase())) {
                                    return null;
                                  }
                                  return (
                                    <option key={group.id} value={group.id}>
                                      {group.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <div className="tsk-display-inline-fields">
                                <input
                                  className="tsk-input-lines"
                                  type="text"
                                  placeholder={t('ui.disp.filter_ph')}
                                  value={this.state.filterGroup}
                                  onChange={(e) => this.setState({ filterGroup: e.target.value })}
                                />
                                <button
                                  type="button"
                                  className="tsk-btn-update"
                                  onClick={() => {
                                    update({
                                      variables: {
                                        input: {
                                          id: device.id,
                                          group_id:
                                            this.state.group_id && String(this.state.group_id).length > 0
                                              ? this.state.group_id
                                              : null,
                                        },
                                      },
                                    });
                                  }}
                                >
                                  <FormattedMessage id="display.management.btn_change" />
                                </button>
                              </div>
                            </div>
                          )}
                        </Mutation>
                      );
                    }}
                  </Query>
                </section>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">
                    <FormattedMessage id="display.mananagement.change_interface" />
                  </h2>
                  {/* What the display is actually RUNNING, which is not always what is assigned:
                      project comes from the assignment, currentInstall from the device's own report
                      after it installed the bundle. A device that never reports shows no version.
                      The name is guarded because the select's onChange below replaces device.project
                      with a bare {id} - so it goes missing as soon as you touch the dropdown. */}
                  <p className="tsk-display-card__current">
                    <FormattedMessage id="display.mananagement.current_interface" />
                    {device.project && device.project.name ? device.project.name : "-"}
                    {device.currentInstall && device.currentInstall.version != null
                      ? ` (v${device.currentInstall.version})`
                      : ""}
                  </p>
                  <Query query={queries.projects.list}>
                    {({ loading: lp, error: ep, data: pdata }) => {
                      if (lp) return t('ui.common.loading');
                      if (ep) return `Error! ${ep.message}`;
                      return (
                        <>
                          <select
                            className="tsk-input-lines"
                            value={device.project == null ? "" : device.project.id}
                            onChange={(e) => {
                              const project_id = e.target.value;
                              this.setState({ project_id });
                              device.project = { id: project_id };
                            }}
                          >
                            <option value="">No project</option>
                            {pdata.projects.map((project) => {
                              if (!project.name.toLowerCase().includes(this.state.filterText.toLowerCase())) {
                                return null;
                              }
                              return (
                                <option value={project.id} key={project.id}>
                                  {project.name}
                                </option>
                              );
                            })}
                          </select>
                          <div className="tsk-display-inline-fields">
                            <input
                              className="tsk-input-lines"
                              type="text"
                              placeholder={t('ui.disp.filter_ph')}
                              value={this.state.filterText}
                              onChange={(e) => this.setState({ filterText: e.target.value })}
                            />
                            <Mutation mutation={queries.displays.update}>
                              {(updateDisplay) => (
                                <button
                                  type="button"
                                  className="tsk-btn-update"
                                  onClick={() => {
                                    if (this.state.project_id !== "") {
                                      updateDisplay({
                                        variables: {
                                          input: { project_id: this.state.project_id, id: device.id },
                                        },
                                      });
                                    }
                                  }}
                                >
                                  <FormattedMessage id="display.mananagement.change" />
                                </button>
                              )}
                            </Mutation>
                          </div>
                        </>
                      );
                    }}
                  </Query>
                </section>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">Location</h2>
                  <Mutation mutation={queries.displays.update}>
                    {(updateLocation) => (
                      <div className="tsk-display-stack">
                        <textarea
                          className="tsk-input-lines tsk-input-lines--textarea"
                          placeholder={t('ui.disp.location_ph')}
                          cols={50}
                          rows={8}
                          value={this.state.location}
                          onChange={(e) => {
                            this.setState({ location: e.target.value, location_change: true });
                          }}
                        />
                        <button
                          type="button"
                          className="tsk-btn-update"
                          onClick={() => {
                            updateLocation({
                              variables: { input: { location: this.state.location, id: device.id } },
                            });
                          }}
                        >
                          Modify location
                        </button>
                      </div>
                    )}
                  </Mutation>
                </section>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">
                    <FormattedMessage id="display.management.alert_section" defaultMessage="État & alerte" />
                  </h2>
                  <Mutation mutation={queries.displays.update}>
                    {(update) => (
                      <div className="tsk-display-alert-row">
                        <label className="tsk-display-checkbox-label" htmlFor="alerte">
                          <input
                            id="alerte"
                            type="checkbox"
                            checked={this.state.alerte}
                            onChange={() => this.setState({ alerte: !this.state.alerte })}
                          />
                          <span><FormattedMessage id="treeosk.displays.alert_display" /></span>
                        </label>
                        <button
                          type="button"
                          className="tsk-btn-update"
                          onClick={() => {
                            update({
                              variables: {
                                input: { id: device.id, need_verify: this.state.alerte },
                              },
                            });
                          }}
                        >
                          <FormattedMessage id="common.button.save" />
                        </button>
                      </div>
                    )}
                  </Mutation>
                </section>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">
                    <FormattedMessage id="display.mananagement.device_actions" defaultMessage="Actions appareil" />
                  </h2>
                  <div className="tsk-display-actions-grid">
                    <Mutation mutation={queries.displays.unlock}>
                      {(unlockDevice) => (
                        <button
                          type="button"
                          className="tsk-button tsk-display-action-secondary"
                          onClick={() => {
                            unlockDevice({ variables: { id: displayId } });
                          }}
                        >
                          <FormattedMessage id="display.mananagement.unlock" />
                        </button>
                      )}
                    </Mutation>
                    <Mutation mutation={queries.displays.clear}>
                      {(clear) => (
                        <button
                          type="button"
                          className="tsk-button tsk-display-action-secondary"
                          onClick={() => {
                            clear({ variables: { id: displayId } });
                          }}
                        >
                          <FormattedMessage id="display.mananagement.cachclear" />
                        </button>
                      )}
                    </Mutation>
                    <Mutation mutation={queries.displays.reboot}>
                      {(reboot) => (
                        <button
                          type="button"
                          className="tsk-button tsk-display-action-secondary"
                          onClick={() => {
                            reboot({ variables: { id: displayId } });
                          }}
                        >
                          <FormattedMessage id="display.mananagement.reboot" />
                        </button>
                      )}
                    </Mutation>
                    <Mutation
                      mutation={queries.displays.screenshot}
                      refetchQueries={() => [
                        { query: queries.displays.getDeviceById, variables: { id: displayId } },
                      ]}
                    >
                      {(screenshot) => (
                        <button
                          type="button"
                          className="tsk-button tsk-display-action-secondary"
                          onClick={() => {
                            screenshot({ variables: { id: displayId } });
                          }}
                        >
                          <FormattedMessage id="display.mananagement.screenshot" />
                        </button>
                      )}
                    </Mutation>
                  </div>
                </section>

                <section className="tsk-display-card tsk-display-card--flush">
                  <DeviceRemoteControl deviceId={device.id} connected={device.connected} />
                </section>

                <section className="tsk-display-card">
                  <h2 className="tsk-display-card__title">
                    <FormattedMessage id="display.mananagement.preview" defaultMessage="Aperçu & position" />
                  </h2>
                  <div className="tsk-display-preview-row">
                    <div
                      className="tsk-display-screenshot-frame"
                      style={{
                        background: device.screenshot_uri
                          ? `url(${device.screenshot_uri})`
                          : undefined,
                      }}
                    >
                      {!device.screenshot_uri && (
                        <span className="tsk-display-screenshot-placeholder">
                          No screenshot
                        </span>
                      )}
                    </div>
                    {last_location && last_location.latitude && last_location.longitude && (
                      <div className="tsk-display-map-wrap">
                        <MapPosition
                          latitude={last_location.latitude}
                          longitude={last_location.longitude}
                        />
                      </div>
                    )}
                  </div>
                </section>

                <section className="tsk-display-danger-zone">
                  <Mutation mutation={queries.displays.deleteDisplay}>
                    {(deleteDisplay) => (
                      <button
                        type="button"
                        className="tsk-button tsk-warning"
                        onClick={() => {
                          confirmDialog("Delete this device now").then(() => {
                            apolloClient
                              .mutate({
                                mutation: queries.displays.deleteDisplay,
                                variables: { id: displayId },
                                refetchQueries: [{ query: queries.displays.listGroup }],
                              })
                              .then((res) => {
                                if (!res.errors && res.data) {
                                  window.location.href = "/admin/displays";
                                }
                              });
                          });
                        }}
                      >
                        <FormattedMessage id="common.button.delete" />
                      </button>
                    )}
                  </Mutation>
                </section>
              </div>
            );
          }}
        </Query>
      </NeedAdmin>
    );
  }
}

export default DisplayManagement;
